import { Stack } from '@mui/material';
import BodyRegular from '@/components/typography/BodyRegular';
type Props = {
  seconds?: number | string;
  minutes?: number | string;
};
const UntilTimeToSendOtp = ({
  seconds,
  minutes
}: Props) => {
  return <Stack direction='row' alignItems='center' justifyContent='center' data-sentry-element="Stack" data-sentry-component="UntilTimeToSendOtp" data-sentry-source-file="UntilTimeToSendOtp.tsx">
      <BodyRegular sx={{
      width: 40,
      textAlign: 'center'
    }} data-sentry-element="BodyRegular" data-sentry-source-file="UntilTimeToSendOtp.tsx">
        {minutes ? minutes?.toString().length > 1 ? minutes : `0${minutes}` : '00'}
        :
        {seconds ? seconds?.toString().length > 1 ? seconds : `0${seconds}` : '00'}
      </BodyRegular>

      <BodyRegular data-sentry-element="BodyRegular" data-sentry-source-file="UntilTimeToSendOtp.tsx">تا ارسال مجدد کد</BodyRegular>
    </Stack>;
};
export default UntilTimeToSendOtp;